import { DataAttributeDefinitions } from 'scrivito'

import { pisaFollowUpActivityDataClass } from './Pisa/FollowUpActivityDataClass'

const attributes: DataAttributeDefinitions = {}

export const FollowUpActivity = pisaFollowUpActivityDataClass(attributes)
